import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=ee7b7420&lang=scss"

const __exports__ = script;

export default __exports__